<template>
  <div class="canvas">
    <!-- <VitePwaManifest /> -->
    <SiteHeader />
    <LazySiteNav />
    <SiteModal />
    <LazyCOverlayLightbox />
    <NuxtPage />
  </div>
</template>

<script lang="ts" setup>
import { site } from '../global';

useSeoMeta({
  title: site.title,
  ogTitle: site.title,
  description: site.description,
  ogDescription: site.description,
  ogSiteName: site.title,
  // ogImage: '',
  twitterCard: 'summary_large_image',
  ogUrl: site.url,
})
// import type { ModalContent } from '~~/types'

// const { modal } = useModal()

// const { button, image } = useDghGroq()
// const { supportsLocalStorage } = useLocalStorage()

// // onMounted(() => {
// //   if (
// //     process.client &&
// //     supportsLocalStorage.value &&
// //     localStorage.getItem('modalClosed') === 'true'
// //   )
// //     modal.active = false
// // })

// const { data: modalContent } = useSanityQuery<ModalContent>(
//   groq`*[_type == "siteSettings"][0].modal {
//     enabled,
//     ${button(true, 'description,\n"image": images[0]' + image + ',')},
//     defined(description) => {description},
//     defined(image) => {image${image}},
//   }`,
//   {},
//   {
//     transform: (
//       data: Omit<ModalContent, 'title'> & { text: string }
//     ): ModalContent => {
//       try {
//         const title = data?.text
//         if (data?.enabled && !!title) modal.active = true

//         return {
//           ...data,
//           text: undefined,
//           title,
//         }
//       } catch (e) {
//         console.log(e)
//       }
//     },
//   }
// )
</script>
